import ActivityProgress from '../ActivityProgress';
import { Container, Description } from './styles';

type ActivityDescriptionProps = {
    progress: number;
    description: string;
};

export const getProgress = (keyCount: number, progress: number) => Math.round(keyCount * progress);

const ActivityDescription = ({ progress, description }: ActivityDescriptionProps) => (
    <Container>
        <ActivityProgress progress={progress} />
        <Description>{description}</Description>
    </Container>
);

export default ActivityDescription;
